// Moved from index.html to bundle for correct loading
import { SupportFab } from '../../components/feature/support/SupportFab.js';

export const initSupportSystem = () => {
    // 1. Safe Start Logic
    let isStartupSafe = false;
    setTimeout(() => isStartupSafe = true, 3000); // 3s Safe Start

    // 2. Initialize FAB
    const appContainer = document.body;

    // Track API
    let fabApi = null;

    fabApi = SupportFab(appContainer, async () => {
        // On Click: Lazy Load Modal (Bundled but deferred execution)
        if (!window.user) {
            if (window.Modal) window.Modal.toast("로그인 후 이용 가능합니다.");
            else alert("로그인 후 이용 가능합니다.");
            return;
        }

        // Dynamic import compatible with bundler
        // Use relative path for esbuild to resolve
        const { SupportMessengerModal } = await import('../../components/feature/support/SupportMessengerModal.js');
        SupportMessengerModal();
    });

    // 3. Visibility Logic
    const checkVisibility = () => {
        if (!fabApi) return;

        // Startup Safety
        if (!isStartupSafe) {
            fabApi.hide();
            requestAnimationFrame(checkVisibility);
            return;
        }

        const hash = window.location.hash;
        const isHome = !hash || hash === '#' || hash === '#/';

        // Logic: Show ONLY when near bottom (Footer area)
        // This avoids cluttering the feed.
        const scrollPosition = window.scrollY + window.innerHeight;
        const totalHeight = document.body.offsetHeight;
        const distanceToBottom = totalHeight - scrollPosition;

        // Show if within 1500px of bottom (Generous range so it appears before they hit dead end)
        // But user said "Only at the end". Let's try 500px or when they stop scrolling?
        // User phrase: "마지막에만 나타남" -> Appears only at the end.
        // Let's set a threshold. 300px from bottom.
        const isNearBottom = distanceToBottom < 800;

        if (isHome && isNearBottom) {
            fabApi.show();
        } else {
            fabApi.hide();
        }
    };

    // Events
    window.addEventListener('scroll', () => {
        if (fabApi) requestAnimationFrame(checkVisibility);
    }, { passive: true });

    window.addEventListener('popstate', () => {
        if (fabApi) requestAnimationFrame(checkVisibility);
    });

    // Initial Check
    checkVisibility();
};
